import { env } from "configs/EnvironmentConfig";
import { TYPE_CLONE } from "constants/IssueInvoiceConstant";
import { BU_STORE_HEADER } from "store/auth/login/actionTypes";
import fetch from "../auth/FetchInterceptor";

const IssueInvoiceService = {};

// List Issue Invoice
IssueInvoiceService.listIssueInvoice = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/invoices`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// Detail HDDT
IssueInvoiceService.detailIssueInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};
// Detail HDDT
IssueInvoiceService.cloneEnvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/clone/${id}`,
    method: "post",
  });
};

// Detail HDDT
IssueInvoiceService.cloneInvoiceWarehouses = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/clone/${id}`,
    method: "post",
  });
};

// Detail HDDT
IssueInvoiceService.cloneWarehousesAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/clone/${id}`,
    method: "post",
  });
};

// Detail tem vé
IssueInvoiceService.detailInvoiceTickets = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// Detail phiếu xuất kho
IssueInvoiceService.detailDeliveryBill = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// Detail phiếu xuất kho gửi bán đại lý
IssueInvoiceService.detailWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// detail-pending-bill
IssueInvoiceService.detailPendingBill = function (data) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/detail-pending-bill`,
    method: "get",
    params: {
      ...data,
    },
  });
};

// view-pending-bill
IssueInvoiceService.viewPendingBill = function (data) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/view-pending-bill`,
    method: "get",
    params: {
      ...data,
    },
  });
};

// Create Issue Invoice
IssueInvoiceService.createIssueInvoice = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoices`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit Issue Invoice
IssueInvoiceService.editIssueInvoice = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoices/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLIssueInvoice
IssueInvoiceService.downloadFileXMLIssueInvoice = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoices/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listIssueInvoiceTickets
IssueInvoiceService.listIssueInvoiceTickets = (
  { params },
  bu_code,
  bu_parent
) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-tickets`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// createIssueInvoiceTickets
IssueInvoiceService.createIssueInvoiceTickets = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// editIssueInvoiceTickets
IssueInvoiceService.editIssueInvoiceTickets = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLIssueInvoiceTickets
IssueInvoiceService.downloadFileXMLIssueInvoiceTickets = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listDeliveryBill
IssueInvoiceService.listDeliveryBill = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listWarehouseAgency
IssueInvoiceService.listWarehouseAgency = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listPendingBills
IssueInvoiceService.listPendingBills = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/pending-bills`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      //   sort: "-invoice_date",
      keywords: params.keywords || "",
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// createDeliveryBill
IssueInvoiceService.createDeliveryBill = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// createWarehouseAgency
IssueInvoiceService.createWarehouseAgency = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// editDeliveryBill
IssueInvoiceService.editDeliveryBill = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "put",
    data,
  });
};

// editWarehouseAgency
IssueInvoiceService.editWarehouseAgency = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLDeliveryBill
IssueInvoiceService.downloadFileXMLDeliveryBill = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// downloadFileXMLWarehouseAgency
IssueInvoiceService.downloadFileXMLWarehouseAgency = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listVats
IssueInvoiceService.listVats = function () {
  return fetch({
    url: `${env.API_MSP}/vats?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "tsuat,ltsuat,id",
      sort: "tsuat",
    },
  });
};

// listPaymentMethods
IssueInvoiceService.listPaymentMethods = function () {
  return fetch({
    url: `${env.API_MSP}/payment-methods?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "htttoan,id",
    },
  });
};

// listCurrencies
IssueInvoiceService.listCurrencies = function () {
  return fetch({
    url: `${env.API_MSP}/currencies?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      //   fields: "exception_content,content,status,maker_date,id",
    },
  });
};

// listBusinessUnits
IssueInvoiceService.getBusinessUnits = function () {
  const buTenant = localStorage.getItem(BU_STORE_HEADER);
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[code]": buTenant,
      fields: "ten,mst,dchi,sdthoai,dctdtu,stknhang,tnhang,fax,website",
      "filter[record_status]": "O",
    },
  });
};

// getEnterpriseByTaxCode
IssueInvoiceService.getEnterpriseByTaxCode = function (taxCode) {
  return fetch({
    url: `${env.API_ENDPOINT_URL}services/msttdn/api/get-enterprise-by-tax-code`,
    method: "get",
    params: {
      taxCode,
    },
  });
};

// releaseIssueInvoice
IssueInvoiceService.releaseIssueInvoice = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseIssueInvoiceTicket
// type :0 ( Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử.)
//       1 (  Chuyển đầy đủ nội dung từng hóa đơn)
IssueInvoiceService.releaseIssueInvoiceTicket = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseDeliveryBill
IssueInvoiceService.releaseDeliveryBill = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseWarehouseAgency
IssueInvoiceService.releaseWarehouseAgency = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseInvoiceTotal
IssueInvoiceService.releaseInvoiceTotal = function (transferData) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/release`,
    method: "post",
    data: {
      ...transferData,
    },
  });
};

// transfer
IssueInvoiceService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

// generateNumberInvoice
IssueInvoiceService.generateNumberInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/generate-number/${id}`,
    method: "get",
  });
};

// generateNumberInvoiceWarehouses
IssueInvoiceService.generateNumberInvoiceWarehouses = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/generate-number/${id}`,
    method: "get",
  });
};

// generateNumberWarehouseAgency
IssueInvoiceService.generateNumberWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/generate-number/${id}`,
    method: "get",
  });
};

// ReplaceIssueInvoice
IssueInvoiceService.replaceIssueInvoice = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoices/replace`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// ReplaceIssueInvoiceTickets
IssueInvoiceService.replaceIssueInvoiceTickets = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// replaceDeliveryBill
IssueInvoiceService.replaceDeliveryBill = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// replaceWarehouseAgency
IssueInvoiceService.replaceWarehouseAgency = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// Adjust IssueInvoice
IssueInvoiceService.adjustIssueInvoice = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoices/adjust`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// Adjust IssueInvoiceTickets
IssueInvoiceService.adjustIssueInvoiceTickets = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// Adjust DeliveryBill
IssueInvoiceService.adjustDeliveryBill = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// adjustWarehouseAgency
IssueInvoiceService.adjustWarehouseAgency = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// reviewPdfInvoice
IssueInvoiceService.reviewPdfInvoice = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/review-pdf/${id}`,
    method: "get",
  });
};

// return-goods
IssueInvoiceService.pdfReturnGoods = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/return-goods/${id}`,
    method: "get",
  });
};

// pdfConvert
IssueInvoiceService.pdfConvert = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/review-convert-pdf/${id}`,
    method: "get",
  });
};

// getReportWord
IssueInvoiceService.getReportWord = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/report-word/${id}`,
    method: "get",
    responseType: "blob",
    params: {
      type,
    },
  });
};

// reviewPdfInvoiceTickets
IssueInvoiceService.reviewPdfInvoiceTickets = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/review-pdf/${id}`,
    method: "get",
  });
};

// deleteInvoice
IssueInvoiceService.deleteInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/${id}`,
    method: "delete",
  });
};

// deleteInvoiceTickets
IssueInvoiceService.deleteInvoiceTickets = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "delete",
  });
};

// deleteDeliveryBill
IssueInvoiceService.deleteDeliveryBill = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "delete",
  });
};

// deleteWarehouseAgency
IssueInvoiceService.deleteWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "delete",
  });
};

// cancel Invoice
IssueInvoiceService.cancelInvoice = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoices/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      attach_ids,
    },
  });
};

// cancel InvoiceTickets
IssueInvoiceService.cancelInvoiceTickets = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// cancelDeliveryBill
IssueInvoiceService.cancelDeliveryBill = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// cancelWarehouseAgency
IssueInvoiceService.cancelWarehouseAgency = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// sendMailInvoice
IssueInvoiceService.sendMailInvoice = function (id, listEmail) {
  return fetch({
    url: `${env.API_MSP}/mails/push`,
    method: "post",
    data: {
      invoice_id: id,
      to_mail: listEmail,
    },
  });
};

// uploadFile
IssueInvoiceService.uploadFile = ({ file, type, isGlobal }) => {
  let url = "invoices/update-file";
  if (isGlobal) {
    url = "resource-global/upload-file";
  }
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "post",
    data: file,
  });
};

// actionWorkflowInvoice
IssueInvoiceService.actionWorkflowInvoice = function (
  id,
  action,
  note = undefined
) {
  return fetch({
    url: `${env.API_MSP}/invoices/workflow/${id}/${action}`,
    method: "post",
    data: {
      note,
    },
  });
};

// CreateIssueInvoiceEnterprise
// Tạo hóa đơn cho doanh nghiệp
IssueInvoiceService.createIssueInvoiceEnterprise = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/clone/${id}/${type}`, // 1 (cùng tháng),3 (khác tháng)
    method: "post",
  });
};

// createIssueInvoiceEnterpriseAdjustAll
// Tạo hóa đơn điều chỉnh giảm 100%
IssueInvoiceService.createIssueInvoiceEnterpriseAdjustAll = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/clone/${id}/${TYPE_CLONE.ADJUST_DECREMENT_100}`,
    method: "post",
  });
};

// uploadFileInvoice
IssueInvoiceService.uploadFileInvoice = function (root_id, attach_ids) {
  return fetch({
    url: `${env.API_MSP}/resource-global/attach`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      type: 1,
    },
  });
};

// exportInvoice
IssueInvoiceService.exportInvoice = function (data, path, bu_code, bu_parent) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/${path}/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code,
      bu_parent,
    },
  });
};

// exportInvoiceTicket
IssueInvoiceService.exportInvoiceTicket = function (data, bu_code, bu_parent) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-tickets/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code,
      bu_parent,
    },
  });
};

// exportInvoiceWarehouse
IssueInvoiceService.exportInvoiceWarehouse = function (
  data,
  bu_code,
  bu_parent
) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-warehouses/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code,
      bu_parent,
    },
  });
};

// exportInvoiceWarehouseAgency
IssueInvoiceService.exportInvoiceWarehouseAgency = function (
  data,
  bu_code,
  bu_parent
) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-agents/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code,
      bu_parent,
    },
  });
};

IssueInvoiceService.invoiceCampaignList = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_parent,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/campaigns`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[store_code]": bu_code,
      //   bu_parent,
    },
  });
};

// uploadCampaignInvoice
IssueInvoiceService.uploadCampaignInvoice = function (
  type,
  report_id,
  store_code
) {
  return fetch({
    url: `${env.API_MSP}/campaigns`,
    method: "post",
    data: {
      type,
      report_id,
      store_code,
    },
  });
};

// Detail lô hóa đơn
IssueInvoiceService.campaignInvoiceDetail = function (id) {
  return fetch({
    url: `${env.API_MSP}/campaigns/${id}`,
    method: "get",
  });
};

// releaseCampaignInvoice
IssueInvoiceService.releaseCampaignInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/campaigns/release/${id}`,
    method: "post",
  });
};

// checkInvoiceStatus
IssueInvoiceService.checkInvoiceStatus = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/check-invoice-status/${id}`,
    method: "get",
  });
};

//
IssueInvoiceService.getDataLink = function (id, isGetChild) {
  return fetch({
    url: `${env.API_MSP}/links/${isGetChild ? "child" : "root"}/${id}`,
    method: "get",
  });
};

//
IssueInvoiceService.getAdjustLimit = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/adjust-limit/${id}`,
    method: "get",
  });
};

// replaceIssueInvoiceTT32
IssueInvoiceService.replaceIssueInvoiceTT32 = function (attach_ids, invoice) {
  return fetch({
    url: `${env.API_MSP}/invoices/replace32`,
    method: "post",
    data: {
      attach_ids,
      invoice,
    },
  });
};

// adjustIssueInvoiceTT32
IssueInvoiceService.adjustIssueInvoiceTT32 = function (
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoices/adjust32`,
    method: "post",
    data: {
      attach_ids,
      adjust_mod,
      invoice,
    },
  });
};

// invoiceMaxDate
IssueInvoiceService.invoiceMaxDate = function (khmhdon, khhdon, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoices/max-date`,
    method: "get",
    params: {
      khmhdon,
      khhdon,
      bu_code,
    },
  });
};

// invoiceMinDate
IssueInvoiceService.invoiceMinDate = function (khmhdon, khhdon, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoices/min-date`,
    method: "get",
    params: {
      khmhdon,
      khhdon,
      bu_code,
    },
  });
};

// downloadZip
IssueInvoiceService.downloadZip = function (ids, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/zip`,
    method: "post",
    responseType: "blob",
    data: {
      ids,
      type,
    },
  });
};

// listInvoiceTCTError
IssueInvoiceService.listInvoiceTCTError = ({ params }, bu_code, bu_parent) => {
  const columnFilter = { ...params.columnFilter } || {};
  // if (columnFilter["filter[ttchung_nlap][eq]"]) {
  //   columnFilter["ttchung_nlap"] = columnFilter["filter[ttchung_nlap][eq]"];
  //   delete columnFilter["filter[ttchung_nlap][eq]"];
  // }
  return fetch({
    url: `${env.API_MSP}/invoices`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: "-checker_date",
      keywords: params.keywords || "",
      // expand: params.expand || "",
      "filter[is_problem]": 1,
      //   "filter[auth_status][!=]": AUTH_STATUS_APPROVE,
      bu_code: bu_code,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

export default IssueInvoiceService;
